import {
    AIR_CONDITIONING_UNIT,
    BATTERY,
    ELECTRIC_BOILER,
    EVCP_AC,
    EVCP_DC,
    EV_V2G,
    HEAT_PUMP,
    SOLAR_PV,
} from "../../../../constants/generalConstants"
import {
    AirConditioningIcon,
    BatteryHalfIcon,
    ElectricBoilerIcon,
    EVChargerIcon,
    HeatPumpIcon,
    SolarPanelIcon,
    V2GIcon,
} from "../../../icons/icons"

export const LCT_TILES = [
    {
        title: "Solar Panel",
        value: SOLAR_PV,
        icon: SolarPanelIcon,
    },
    {
        title: "Battery",
        value: BATTERY,
        icon: BatteryHalfIcon,
    },
    {
        title: "Vehicle to Grid (V2G)",
        value: EV_V2G,
        icon: V2GIcon,
    },
    {
        title: "Heat Pump",
        value: HEAT_PUMP,
        icon: HeatPumpIcon,
    },
    {
        title: "Electric Boiler",
        value: ELECTRIC_BOILER,
        icon: ElectricBoilerIcon,
    },
    {
        title: "Air Conditioning Unit",
        value: AIR_CONDITIONING_UNIT,
        icon: AirConditioningIcon,
    },
    {
        title: "EV Charger (AC)",
        value: EVCP_AC,
        icon: EVChargerIcon,
    },
    {
        title: "EV Charger (DC)",
        value: EVCP_DC,
        icon: EVChargerIcon,
    },
]
